module.exports = __webpack_public_path__ + "static/img/3.2e42e7d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/3.png
// module id = o/z0
// module chunks = 0